<template>
  <div class="avatar">
    <el-avatar class="avatar__photo" :size="30" :src="photo"></el-avatar>
    <div class="avatar__name">{{ name }}</div>
  </div>
</template>

<script>
export default {
  name: "AppAvatar",
  props: {
    name: String,
    photo: String
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.avatar {
  display: flex;
  align-items: center;

  .avatar__photo {
    display: block;
  }

  .avatar__name {
    padding-left: 5px;
  }
}
</style>
